module.exports = __webpack_public_path__ + "img/singlang-2019-1.75a5902f.png";